import { render, staticRenderFns } from "./QaQuestionList.vue?vue&type=template&id=22c23b0f&scoped=true&"
import script from "@/scripts/QA/QuestionList/components/QaQuestionList?vue&type=script&lang=js&"
export * from "@/scripts/QA/QuestionList/components/QaQuestionList?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c23b0f",
  null
  
)

export default component.exports